"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderConfirmationDetails = void 0;
const react_1 = __importDefault(require("react"));
const router_1 = require("next/router");
const styled_components_1 = require("styled-components");
const canvas_box_1 = require("../canvas-box");
const view_1 = require("../html-widget/view");
const link_1 = require("../link");
const media_1 = require("../media");
const product_contributors_1 = require("../product-contributors");
const themed_text_1 = require("../themed-text");
const ThankYouPageDescription = (props) => {
    var _a, _b, _c;
    return (react_1.default.createElement(canvas_box_1.CanvasItem, { margin: `${props.margin} 0px` },
        react_1.default.createElement(themed_text_1.ThemedParagraph, { font: (_a = props.descriptionTextFont) !== null && _a !== void 0 ? _a : 'basePlus', spacing: (_b = props.descriptionTextSpacing) !== null && _b !== void 0 ? _b : 'extraLarge', "data-cy": "order-confirmation-details-thank-you-page-description" }, props.thankYouPageDescriptionString),
        react_1.default.createElement(themed_text_1.ThemedParagraph, { font: (_c = props.descriptionTextFont) !== null && _c !== void 0 ? _c : 'basePlus', "data-cy": "order-confirmation-details-thank-you-page-yms-msg" }, (0, view_1.SafeHtmlParse)(props.thankYouPageYmsMsg))));
};
const OrderConfirmationDetails = (_a) => {
    var { productContributorsProps, productImageProps, titleProps, imageMaxWidth = '200px' } = _a, props = __rest(_a, ["productContributorsProps", "productImageProps", "titleProps", "imageMaxWidth"]);
    const router = (0, router_1.useRouter)();
    const theme = (0, styled_components_1.useTheme)();
    const { mediumPlus, micro } = theme.spacings;
    const { isMobile, thankYouPageDescriptionString } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(canvas_box_1.CanvasContainer, { direction: "row", "data-cy": "order-confirmation-details", wrap: "nowrap" },
            react_1.default.createElement(canvas_box_1.CanvasItem, null,
                react_1.default.createElement(media_1.Media, { mediaSrcType: 1, mediaSrcUrl: productImageProps === null || productImageProps === void 0 ? void 0 : productImageProps.mediaSrcUrl, alt: productImageProps.alt, maxWidth: imageMaxWidth, onClick: () => router.push(props.productHref) })),
            react_1.default.createElement(canvas_box_1.CanvasContainer, { direction: "column", margin: `0px 0px 0px ${mediumPlus}`, width: "auto", height: "fit-content" },
                react_1.default.createElement(themed_text_1.ThemedSpan, null, props.youHavePurchasedCopy),
                react_1.default.createElement(canvas_box_1.CanvasItem, { margin: `${mediumPlus} 0px` },
                    react_1.default.createElement(themed_text_1.ThemedSpan, { bold: true, font: "basePlus", "data-cy": "order-confirmation-details-product-title" }, titleProps === null || titleProps === void 0 ? void 0 : titleProps.title),
                    react_1.default.createElement(product_contributors_1.ProductContributors, Object.assign({}, productContributorsProps))),
                !isMobile && thankYouPageDescriptionString && (react_1.default.createElement(ThankYouPageDescription, { thankYouPageDescriptionString: thankYouPageDescriptionString, thankYouPageYmsMsg: props.thankYouPageYmsMsg })),
                !thankYouPageDescriptionString && (react_1.default.createElement(link_1.Link, { "data-cy": "order-confirmation-details-view-your-order-link", onClick: () => {
                        router.push(props.orderDetailsUrl);
                    } }, props.viewYourOrderDetailsCopy)))),
        isMobile && thankYouPageDescriptionString && (react_1.default.createElement(canvas_box_1.CanvasContainer, { direction: "row", margin: `0px 0px 0px ${micro}`, height: "fit-content" },
            react_1.default.createElement(canvas_box_1.CanvasItem, { margin: `${micro} 0px` },
                react_1.default.createElement(ThankYouPageDescription, { descriptionTextFont: "micro", descriptionTextSpacing: "large", thankYouPageDescriptionString: thankYouPageDescriptionString, thankYouPageYmsMsg: props.thankYouPageYmsMsg }))))));
};
exports.OrderConfirmationDetails = OrderConfirmationDetails;
__exportStar(require("./types"), exports);
